import { Box, styled } from '@mui/material';
import { UPButtonStyledWithNoPadding } from 'components/button/styles';

/** Content height a table row can hold without growing: 56px row less its 2 × 16px padding. */
const ROW_CONTENT_HEIGHT = '24px';

/** Holds the hover-only row actions at a fixed height, so showing them cannot resize the row. */
export const RowActionsContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: ROW_CONTENT_HEIGHT,
  // The buttons no longer carry MUI's own padding, so the spacing between the icons is set here.
  gap: '12px',
});

/**
 * Icon-only action button for the Active links table.
 *
 * MUI's Button carries roughly 36px of intrinsic height — a 1.75 line-height plus its own
 * padding — which on top of the cell's vertical padding overflowed the 56px row and made rows
 * visibly grow on hover. Only the icon needs to be hit-testable here, so the button is
 * collapsed onto its content box.
 */
export const RowActionButton = styled(UPButtonStyledWithNoPadding)({
  minWidth: 0,
  padding: 0,
  height: ROW_CONTENT_HEIGHT,
  lineHeight: 1,
});

/**
 * Pill for the Active links Type column. Application links take the primary green tint so
 * they read as the new kind at a glance; onboarding links keep the neutral gray.
 */
export const LinkTypeBadgeStyled = styled(Box, {
  shouldForwardProp: prop => prop !== 'isApplication',
})<{ isApplication: boolean }>(({ theme, isApplication }) => ({
  display: 'inline-block',
  padding: '2px 10px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  backgroundColor: isApplication ? theme.palette.primary.dark : theme.palette.info.dark,
  color: isApplication ? theme.palette.primary.main : theme.palette.info.contrastText,
}));
